import { formatDate } from "../../../../functions/dateTime/formatDate";
import {
  UserDetailItem,
  UserDetailsWrapper,
  UserInfoBoxTitle,
  UserBoxWrapper,
} from "./UserDialogUi";

const CompanyInfo = ({ userData }) => {
  return (
    <UserBoxWrapper>
      <UserInfoBoxTitle title="Company Info" />
      <UserDetailsWrapper>
        <UserDetailItem label="Salary" value={userData.salary} />
        <div className="w-full">
          <p className="text-gray-400 text-[15px] max-lg:text-sm">Status</p>
          <p
            className={`${
              userData.isActive ? "bg-green-3" : "bg-gray-500"
            } text-white w-max px-3 rounded-full text-sm`}
          >
            {userData.isActive ? "Active" : "In Active"}
          </p>
        </div>
      </UserDetailsWrapper>
      <UserDetailsWrapper>
        <UserDetailItem
          label="JBCC Admin"
          value={userData.jbccAdmin.fullName}
        />
        <UserDetailItem
          label="JBCC Supervisor"
          value={userData.jbccSupervisor.fullName}
        />
      </UserDetailsWrapper>
      <UserDetailsWrapper>
        <UserDetailItem label="JN Admin" value={userData.jnAdmin.fullName} />
        <UserDetailItem
          label="JN Supervisor"
          value={userData.jnSupervisor.fullName}
        />
      </UserDetailsWrapper>
      <UserDetailsWrapper>
        <UserDetailItem
          label="Created"
          value={formatDate(userData.createdAt)}
        />
        {userData.dateOfJoining && (
          <UserDetailItem
            label="Joining Date"
            value={formatDate(userData.dateOfJoining)}
          />
        )}
      </UserDetailsWrapper>
      <UserDetailsWrapper>
        {userData.disabledAt && (
          <UserDetailItem
            label="Disabled"
            value={formatDate(userData.disabledAt)}
          />
        )}
      </UserDetailsWrapper>
    </UserBoxWrapper>
  );
};

export default CompanyInfo;
